export const MEASUREMENT_MIN_CM = 1;
export const MEASUREMENT_MAX_CM = 300;
export const MEASUREMENT_STEP_CM = 0.1;
export const MEASUREMENT_DECIMALS = 1;
export const CUSTOM_METRIC_NAME_MAX_LENGTH = 40;
export const MEASUREMENT_HISTORY_PAGE_SIZE = 10;
